import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ButtonInput } from "src/app/atoms/button/button.component";
import { HelperModalControllerService } from "src/app/helpers/helper-modal-controller.service";
import { TranslatePipe } from "src/app/pipes/translate.pipe";

@Component({
  selector: 'app-generic',
  templateUrl: './generic.component.html',
  styleUrls: ['./generic.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe
  ]
})
export class GenericComponent {
  @Input('title') _title!: string;
  @Input('description') _description!: string;
  @Input('buttons') _buttons!: Array<ButtonInput>;

  constructor(
    private helperModalControllerService: HelperModalControllerService
  ) { }

  dismiss(data: Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>>, role: string) {
    this.helperModalControllerService.dismiss(data, role);
  }
}
